const SITE_URL = "https://kalpilli.com"
const { LEVELS } = require("../data/levels")

const INDEX_ROBOTS =
  "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"

const PAGE_METADATA = Object.freeze({
  home: {
    pathname: "/",
    title: "Escuela Montessori en Benito Juárez, CDMX",
    description:
      "Escuela Montessori en CDMX: Nido, maternal, preescolar y primaria en San Pedro de los Pinos, Benito Juárez. Conoce los niveles y solicita una visita.",
    image: "/og/kalpilli.png",
  },
  inscripciones: {
    pathname: "/inscripciones/",
    title: "Inscripciones Montessori 2026-2027",
    description:
      "Consulta el proceso de inscripción, costos, requisitos y documentación para el ciclo 2026-2027 en Montessori Kalpilli.",
    image: "/og/inscripciones.webp",
  },
  instalaciones: {
    pathname: "/instalaciones/",
    title: "Instalaciones Montessori Kalpilli",
    description:
      "Conoce los ambientes e instalaciones de Montessori Kalpilli en San Pedro de los Pinos, Ciudad de México.",
    image: "/og/instalaciones.webp",
  },
  metodoMontessori: {
    pathname: "/metodo-montessori/",
    title: "Método Montessori",
    description:
      "Conoce los principios del método Montessori: autonomía, ambiente preparado, materiales concretos y respeto al ritmo de cada niño.",
    image: "/og/metodo-montessori.jpg",
  },
  ofertaAcademica: {
    pathname: "/oferta-academica/",
    title: "Oferta Académica Montessori",
    description:
      "Conoce la oferta académica de Kalpilli: Nido, Comunidad Infantil, Casa de Niños, Primaria Montessori, programas y talleres complementarios.",
    image: "/og/oferta-academica.jpg",
  },
  ...Object.fromEntries(
    LEVELS.map(level => [
      level.metadataKey,
      Object.freeze({
        pathname: level.pathname,
        title: level.heading,
        description: level.metaDescription,
        image: level.image,
      }),
    ])
  ),
  significadoKalpilli: {
    pathname: "/significado-de-kalpilli/",
    title: "Historia y significado de Kalpilli",
    description:
      "Conoce el origen náhuatl de la palabra Kalpilli y su relación con la comunidad, la educación y la identidad de la escuela.",
    image: "/og/significado-de-kalpilli.webp",
  },
  privacidad: {
    pathname: "/aviso-de-privacidad/",
    title: "Aviso de Privacidad",
    description:
      "Consulta el aviso de privacidad de Montessori Kalpilli y el tratamiento aplicable a los datos personales.",
    image: "/og/aviso-de-privacidad.png",
  },
  notFound: {
    pathname: "/404/",
    title: "Página no encontrada",
    description:
      "La página solicitada no existe. Regresa al inicio de Montessori Kalpilli para continuar navegando.",
    image: "/og/pagina-no-encontrada.png",
    noIndex: true,
  },
})

const LEGACY_REDIRECTS = Object.freeze([
  ["/Inscripciones", "/inscripciones/"],
  ["/Inscripciones/", "/inscripciones/"],
  ["/Instalaciones", "/instalaciones/"],
  ["/Instalaciones/", "/instalaciones/"],
  ["/MetodoMontessori", "/metodo-montessori/"],
  ["/MetodoMontessori/", "/metodo-montessori/"],
  ["/OfertaAcademica", "/oferta-academica/"],
  ["/OfertaAcademica/", "/oferta-academica/"],
  ["/ProgramasKalpilli", "/oferta-academica/"],
  ["/ProgramasKalpilli/", "/oferta-academica/"],
  ["/programas-kalpilli", "/oferta-academica/"],
  ["/programas-kalpilli/", "/oferta-academica/"],
  ["/kalpilliMeaning", "/significado-de-kalpilli/"],
  ["/kalpilliMeaning/", "/significado-de-kalpilli/"],
  ["/privacy", "/aviso-de-privacidad/"],
  ["/privacy/", "/aviso-de-privacidad/"],
  ["/conoce-montessori", "/metodo-montessori/"],
  ["/conoce-montessori/", "/metodo-montessori/"],
  ["/primaria", "/primaria-montessori/"],
  ["/primaria/", "/primaria-montessori/"],
  ["/contacto", "/"],
  ["/contacto/", "/"],
].map(([fromPath, toPath]) =>
  Object.freeze({ fromPath, toPath, isPermanent: true, ignoreCase: false })
))

const OG_IMAGE_ASSETS = Object.freeze([
  { sourcePath: "src/images/kalpilliDark.png", publicPath: "og/kalpilli.png" },
  { sourcePath: "src/images/instalaciones.png", publicPath: "og/inscripciones.webp" },
  { sourcePath: "src/images/instalaciones-2026/01.webp", publicPath: "og/instalaciones.webp" },
  { sourcePath: "src/images/maria.jpg", publicPath: "og/metodo-montessori.jpg" },
  { sourcePath: "src/images/academy/prescolar.jpg", publicPath: "og/oferta-academica.jpg" },
  { sourcePath: "src/images/academy/madre.jpg", publicPath: "og/nido-montessori.jpg" },
  { sourcePath: "src/images/academy/bebe.jpg", publicPath: "og/comunidad-infantil-montessori.jpg" },
  { sourcePath: "src/images/academy/prescolar.jpg", publicPath: "og/casa-de-ninos-montessori.jpg" },
  { sourcePath: "src/images/instalaciones-2026/01.webp", publicPath: "og/primaria-montessori.webp" },
  { sourcePath: "src/images/capullis.jpg", publicPath: "og/significado-de-kalpilli.webp" },
  { sourcePath: "src/images/kalpilliDark.png", publicPath: "og/aviso-de-privacidad.png" },
  { sourcePath: "src/images/kalpilliDark.png", publicPath: "og/pagina-no-encontrada.png" },
].map(asset => Object.freeze(asset)))

function normalizePathname(pathname = "/") {
  let value = String(pathname || "/").trim()

  if (/^https?:\/\//i.test(value)) {
    value = new URL(value).pathname
  } else {
    value = value.split(/[?#]/, 1)[0]
  }

  value = `/${value}`.replace(/\/{2,}/g, "/")
  if (value !== "/" && !value.endsWith("/")) {
    value += "/"
  }

  return value
}

function toAbsoluteUrl(value, siteUrl = SITE_URL) {
  if (/^https?:\/\//i.test(value)) {
    return new URL(value).toString()
  }

  const base = `${String(siteUrl).replace(/\/+$/, "")}/`
  return new URL(String(value).replace(/^\/+/, ""), base).toString()
}

function buildSeoMetadata({
  siteMetadata,
  title,
  description,
  pathname,
  image,
  noIndex = false,
}) {
  const required = { title, description, pathname, image }
  for (const [name, value] of Object.entries(required)) {
    if (!value) {
      throw new TypeError(`SEO metadata requires a ${name}`)
    }
  }

  const siteTitle = siteMetadata?.title
  const siteUrl = siteMetadata?.siteUrl || SITE_URL
  const fullTitle = siteTitle ? `${title} | ${siteTitle}` : title
  const canonicalUrl = toAbsoluteUrl(normalizePathname(pathname), siteUrl)
  const imageUrl = toAbsoluteUrl(image, siteUrl)

  return {
    title: fullTitle,
    description,
    canonicalUrl,
    imageUrl,
    robots: noIndex ? "noindex, nofollow" : INDEX_ROBOTS,
    openGraph: {
      type: "website",
      url: canonicalUrl,
      title: fullTitle,
      description,
      image: imageUrl,
    },
    twitter: {
      card: "summary_large_image",
      url: canonicalUrl,
      title: fullTitle,
      description,
      image: imageUrl,
    },
  }
}

function isSitemapPage(pathname, redirects = LEGACY_REDIRECTS) {
  const normalized = normalizePathname(pathname)
  const lowerPath = normalized.toLowerCase()
  const excludedSystemPaths = new Set([
    "/404/",
    "/404.html/",
    "/dev-404-page/",
  ])
  const redirectPaths = new Set(
    redirects.map(redirect => normalizePathname(redirect.fromPath))
  )

  return !excludedSystemPaths.has(lowerPath) && !redirectPaths.has(normalized)
}

function escapeXml(value) {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&apos;")
}

function buildSitemapXml(
  pagePaths,
  redirects = LEGACY_REDIRECTS,
  siteUrl = SITE_URL
) {
  const canonicalPaths = [
    ...new Set(
      pagePaths
        .filter(pathname => isSitemapPage(pathname, redirects))
        .map(normalizePathname)
    ),
  ].sort((left, right) => {
    if (left === "/") return -1
    if (right === "/") return 1
    return left.localeCompare(right)
  })

  const urls = canonicalPaths
    .map(pathname => {
      const url = escapeXml(toAbsoluteUrl(pathname, siteUrl))
      return `  <url>\n    <loc>${url}</loc>\n  </url>`
    })
    .join("\n")

  return [
    '<?xml version="1.0" encoding="UTF-8"?>',
    '<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">',
    urls,
    "</urlset>",
    "",
  ].join("\n")
}

module.exports = {
  INDEX_ROBOTS,
  LEGACY_REDIRECTS,
  OG_IMAGE_ASSETS,
  PAGE_METADATA,
  SITE_URL,
  buildSeoMetadata,
  buildSitemapXml,
  isSitemapPage,
  normalizePathname,
  toAbsoluteUrl,
}
